module.exports = __webpack_public_path__ + "static/media/22.6bc16320.jpg";